import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@sal/authentication.react';
import { CircularProgress, Box } from '@mui/material';
import {
	PermissionRequirement,
	useHasPermissions,
} from '../code/permissions';

interface RequirePermissionProps {

	requirements: PermissionRequirement[];
}


const RequirePermission = ({ requirements }: RequirePermissionProps) => {
	const { isLoggedIn, loading } = useAuth();
	const hasAllPermissions = useHasPermissions(requirements);

	if (loading) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
				<CircularProgress />
			</Box>
		);
	}

	if (!isLoggedIn) {
		return <Navigate to="/Login" replace />;
	}

	if (!hasAllPermissions) {
		return <Navigate to="/AccessDenied" replace />;
	}

	return <Outlet />;
};

export default RequirePermission;
